import { Link } from "react-router-dom";
import { useStateValue } from "../../context/StateProvider";
import { renderWithMentions, getFullName } from "../../utils/mentions";

// Render a feed post / comment body with @mentions highlighted.
// Each matched mention links to that user's profile page.
export default function MentionText({ text, className = "" }) {
  const [{ users }] = useStateValue();
  if (!text) return null;
  const tokens = renderWithMentions(text, users);
  return (
    <span className={className}>
      {tokens.map((tok, i) => {
        if (typeof tok === "string") return <span key={i}>{tok}</span>;
        const u = tok.mention;
        return (
          <Link
            key={i}
            to={`/dashboard/profile/${u.id}`}
            className="text-indigo-600 font-semibold hover:underline"
            onClick={(e) => e.stopPropagation()}
          >
            @{getFullName(u)}
          </Link>
        );
      })}
    </span>
  );
}
